
    var riot = require('riot')
    
riot.tag2('analysis_types_input', '<div class="form-group"> <label class="control-label col-sm-4">Analysis Types Covered</label> <div class="col-sm-8"> <div class="input-group"> <table class="table table-condensed"> <thead> <tr class="active"> <th class="col-sm-10">Type</th> <th class="col-sm-1">Weeks</th> <th class="col-sm-1"></th> </tr> </thead> <tbody> <tr each="{type, i in types}"> <td> <formselect name="type" options="{parent.opts.options}" default="Please Select" value="{parent.types[i]}" width2="12" onupdate="{handleUpdate.bind(null, i)}"></formselect> </td> <td> <forminput name="length" value="{parent.lengths[i]}" width2="12" onupdate="{handleUpdate.bind(null, i)}"></forminput> </td> <td> <confirm onconfirm="{parent.remove.bind(null,i)}"> <div class="btn btn-danger">X</div> </confirm> </td> </tr> </tbody> </table> <button onclick="{add}" class="btn btn-primary">Add Analysis Type</button> <div if="{opts.buttonafter}" class="input-group-btn"> <button riot-tag="i18n" content="{opts.buttonafter}" onclick="{opts.buttonafterclick}" class="btn btn-default"></button> </div> </div> </div> </div>', 'analysis_types_input table .form-group { margin-bottom: 0; }', '', function(opts) {
this.types = [];

this.on('update', function() {
  this.types = Array.isArray(opts.types) ? opts.types : [opts.types];
  return this.lengths = Array.isArray(opts.lengths) ? opts.lengths : [opts.lengths];
});

this.remove = (function(_this) {
  return function(idx) {
    _this.types.splice(idx, 1);
    _this.lengths.splice(idx, 1);
    return opts.onupdate(_this.types, _this.lengths);
  };
})(this);

this.handleUpdate = (function(_this) {
  return function(idx, val) {
    _this[val.name + 's'][idx] = val.value;
    return opts.onupdate(_this.types, _this.lengths);
  };
})(this);

this.add = (function(_this) {
  return function(e) {
    _this.types.push("");
    _this.lengths.push("");
    return opts.onupdate(_this.types, _this.lengths);
  };
})(this);
});
riot.tag2('experience_details', '<raw content="{opts.opts.experience_details}"></raw> <ul class="nav nav-tabs"> <li each="{ref, i in opts.psedata.simulations}" class="{active:parent.simulation_id == i}"><a href="./experience_details/{i+1}" class="heading btn">{i+1}</a></li> <li><a onclick="{addProject}" class="btn btn-success">Add Project</a></li> <li> <confirm onconfirm="{deleteProject}"><a class="btn btn-danger">Delete Project</a></confirm> </li> </ul> <div class="tab-content"> <div class="tab-pane {active: simulation}"> <div class="col-xs-10 col-xs-offset-1"> <form class="form-horizontal"> <popover parent="{infoParent}"> <raw content="{parent.info}"></raw> </popover> <forminput label="Job/Project Title *" name="comp_job" value="{simulation.comp_job}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.experience.comp_job)}" isrequired></forminput> <formtextarea label="Brief Engineering Description *" name="comp_description" value="{simulation.comp_description}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.experience.comp_description)}" isrequired></formtextarea> <forminput label="Applicants Analysis &amp; Simulation Role *" name="comp_role" value="{simulation.comp_role}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.experience.comp_role)}" isrequired></forminput> <forminput label="Duration in weeks covering applicants input *" name="comp_weeks" value="{simulation.comp_weeks}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.experience.comp_weeks)}" isrequired></forminput> <formdateinput label="Start Date*" name="comp_start" value="{simulation.comp_start}" dateformat="dd/MM/yyyy" onupdate="{handleUpdate}" isrequired></formdateinput> <formdateinput label="End Date*" name="comp_end" value="{simulation.comp_end}" dateformat="dd/MM/yyyy" onupdate="{handleUpdate}" isrequired></formdateinput> <analysis_types_input label="Analysis Types Covered" types="{simulation.comp_types}" lengths="{simulation.comp_length}" options="{opts.selects.analysisTypes}" onupdate="{handleUpdateAnalysisTypes}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.experience.comp_types)}"></analysis_types_input> <forminput label="Product types covered *" name="comp_products" value="{simulation.comp_products}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.experience.comp_products)}" isrequired></forminput> <forminput label="Analysis and simulation tools used *" name="comp_tools" value="{simulation.comp_tools}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.experience.comp_tools)}" isrequired></forminput> <fileinput label="Upload File" files="{simulationFiles}" onupdate="{handleUpload}" onremove="{handleRemove}"></fileinput> </form> </div> </div> </div>', '', '', function(opts) {
this.files = [];

this.simulations = [];

this.infobutton = "<span class=\"fa fa-info\" style=\"pointer-events:none\"></span>";

this.mounted = false;

this.on('mount', function() {
  this.mounted = true;
  if (opts.errors != null) {
    return setTimeout((function(_this) {
      return function() {
        return _this.checkErrors();
      };
    })(this));
  }
});

this.showInfo = (function(_this) {
  return function(info, e) {
    _this.info = info;
    _this.infoParent = e.target;
    _this.tags.popover.clicked(e);
    return _this.update();
  };
})(this);

this.on('update', function() {
  if (opts.files != null) {
    this.files = opts.files.filter(function(f) {
      return f.path.match(/^se_/);
    });
  }
  if ((opts.errors != null) && this.mounted) {
    this.checkErrors();
  }
  if (opts.psedata != null) {
    return this.load();
  }
});

this.checkErrors = (function(_this) {
  return function() {
    _this.simulationErrors = opts.errors.filter(function(e) {
      return e.tab === 'simulations';
    }).map(function(e) {
      return e.field;
    });
    _this.update();
    return _this.simulationErrors.forEach(function(field) {
      var ref;
      if (field === 'comp_start' || field === 'comp_end') {
        return _this.tags[field].tags['forminput'].tags['formgroup'].trigger('validate');
      } else {
        return (ref = _this.tags[field].tags['formgroup']) != null ? ref.trigger('validate') : void 0;
      }
    });
  };
})(this);

this.load = function() {
  var ref, regex;
  this.simulations = opts.psedata.simulations;
  this.simulation_id = opts.params.simulation_id != null ? opts.params.simulation_id - 1 : 0;
  if (((ref = this.simulations) != null ? ref[this.simulation_id] : void 0) != null) {
    this.simulation = this.simulations[this.simulation_id];
  }
  regex = new RegExp('se_' + (this.simulation_id + 1) + '_');
  this.simulationFiles = this.files.filter(function(f) {
    return f.path.match(regex);
  });
  return this.update();
};

this.addProject = function() {
  this.simulations.push({});
  opts.page.redirect('experience_details/' + this.simulations.length);
  return this.update();
};

this.deleteProject = (function(_this) {
  return function() {
    _this.simulations.splice(_this.simulation_id, 1);
    opts.page.redirect('experience_details/' + _this.simulations.length);
    return _this.update();
  };
})(this);

this.handleUpdate = (function(_this) {
  return function(val) {
    _this.simulation[val.name] = val.value;
    return opts.onupdate('simulations', _this.simulation_id, _this.simulation);
  };
})(this);

this.handleUpdateAnalysisTypes = (function(_this) {
  return function(types, lengths) {
    _this.simulation.comp_types = types;
    _this.simulation.comp_length = lengths;
    return opts.onupdate('simulations', _this.simulation_id, _this.simulation);
  };
})(this);

this.handleUpload = (function(_this) {
  return function(val) {
    var data, file;
    if ((val != null ? val[0] : void 0) != null) {
      file = val[0];
      data = new FormData();
      data.append('file', file);
      data.append('name', 'se_' + (_this.simulation_id + 1) + "_" + file.name);
      return fetch('/duocms/api/pse/file', {
        method: 'POST',
        credentials: "include",
        headers: {
          'x-csrf-token': window.csrf
        },
        body: data
      }).then(function() {
        return opts.onupdate('files', 'add', {
          path: 'se_' + (_this.simulation_id + 1) + "_" + file.name
        });
      });
    }
  };
})(this);

this.handleRemove = (function(_this) {
  return function(file) {
    return fetch('/duocms/api/pse/file?path=' + file.path, {
      method: 'DELETE',
      credentials: "include",
      headers: {
        'x-csrf-token': window.csrf
      }
    }).then(function() {
      return opts.onupdate('files', 'remove', file);
    });
  };
})(this);
});
    
  